@if (params.data.status === "active") {
  <a panButton [href]="cameraUrl()" target="_blank" color="info" icon="open_in_new" matTooltip="View Camera"></a>
}
